module.exports = __webpack_public_path__ + "media/images/www/company/cash-payment-bills-acff70442a901d51e2b7f838bcf1dfa3.svg";